<script setup lang="ts">
  import type { StarterBlockData } from '@/models/chat';

  const { title } = defineProps<StarterBlockData>();

  const emit = defineEmits(['send']);

  const send = () => {
    emit('send', title);
  };
</script>

<template>
  <div
    class="chat-starter-block"
    @click.prevent.stop="send">
    <div class="chat-starter-block__wrapper">
      <div class="chat-starter-block__top">{{ title }}</div>
      <div class="chat-starter-block__bottom">
        <button
          aria-label="Start"
          @click.prevent.stop="send" />
      </div>
    </div>
  </div>
</template>
